import React, { useEffect, useState, createContext } from "react";
import { useParams } from "react-router-dom";
import "./common.css";
import API_URL from "../common/Apiurl";
import { AiFillEye } from "react-icons/ai";
import SuccessMessage from "../common/Message";
import SearchLocationInput from "./GooglePlcasesApi";
import MapComponent from "./Map";

function Editemployer() {
  const apiUrl = API_URL;
  const [items, setItems] = useState([]);
  const [inputType, setInputType] = useState("password");
  const viewId = useParams();
  const employerId = viewId.employerid;
  const [successMessages, setSuccessMessages] = useState([]);
  const userInfo = localStorage.getItem("user-info");
  const getadminId = JSON.parse(userInfo).data.id;
  // new
  const [employerName, setEmployername] = useState([]);
  const [getemployerName, setGetemployername] = useState(" ");
  const [emailaddress, setEmailaddress] = useState(" ");
  const [getemailaddress, setgetemailaddress] = useState(" ");
  const [information, setInformation] = useState(" ");
  const [getinformation, setGetinformation] = useState(" ");
  const [company, setCompany] = useState(" ");
  const [getcompanyname, setcompanyname] = useState(" ");
  const [mobilenumber, setMobilenumber] = useState(" ");
  const [getnumber, setGetnumber] = useState(" ");
  const [passwordvalue, setPassword] = useState(" ");
  const [driving_licence, setDivingLicense] = useState(null);
  const [address, setAddress] = useState(null);
  const [image1, setImage1] = useState();
  const [image2, setImage2] = useState();
  const [is_driving_licence, setIsDivingLicense] = useState(false);
  const [is_address, setIsAddress] = useState(false);

  // new
  // const [query, setQuery] = useState("");
  const [selectedLocation, setSelectedLocation] = useState({
    lat: "",
    lng: " ",
  });
  useEffect(() => {
    const getComments = async () => {
      try {
        const postData = {
          employer_id: employerId,
        };
        const res = await fetch(`${apiUrl}/admin/viewemployer`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(postData),
        });
        const data = await res.json();
        if (data.status !== 200) {
          throw new Error("Data not found");
        }
        setItems(data.data);
        setEmployername(data.data.name);
        setEmailaddress(data.data.email);
        setInformation(data.data.informations);
        setCompany(data.data.company_name);
        setMobilenumber(data.data.mobile_number);
        setIsDivingLicense(data.data.driving_licence);
        setIsAddress(data.data.address_proof);
      } catch (error) {
        console.error("Error ", error);
      }
    };
    getComments();
  }, []);
  const handleDivingLicenseChange = async (e) => {
    // e.preventDefault();
    console.log(e.target.files)
    // setImage1(e.target.files[0]);
    // console.log(image1)
    const formData = new FormData();
    formData.append('type', 'driving_licence');
    formData.append('driving_licence', e.target.files[0]);
    formData.append('user_id', items.userId);
    
    const employerresult = await fetch(`${apiUrl}/admin/uploadDocumentsForAdmin`, {
      method: "POST",
      body: formData,
      
    });
    const updatedData = await employerresult.json();
    if (updatedData.status === 200) {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    } else {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    }
  };
  const handleAddressChange = async (e) => {
    // setImage2(e.target.files[0]);
    const formData = new FormData();
    formData.append('type', 'address');
    formData.append('address', e.target.files[0]);
    formData.append('user_id', items.userId);

    const employerresult = await fetch(`${apiUrl}/admin/uploadDocumentsForAdmin`, {
      method: "POST",
      body: formData,
    });
    const updatedData = await employerresult.json();
    if (updatedData.status === 200) {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    } else {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    }
  };

  // updated data
  const getname = (e) => {
    setEmployername(e.target.value);
    setGetemployername(e.target.value);
  };
  const getemailid = (e) => {
    setEmailaddress(e.target.value);
    setgetemailaddress(e.target.value);
  };
  const getinfo = (e) => {
    setInformation(e.target.value);
    setGetinformation(e.target.value);
  };
  const getcompany = (e) => {
    setCompany(e.target.value);
    setcompanyname(e.target.value);
  };
  const getmobilenumber = (e) => {
    setMobilenumber(e.target.value);
    setGetnumber(e.target.value);
  };
  const getpassword = (e) => {
    setPassword(e.target.value);
  };
  // updated data

  const updateemployer = async (e) => {
    e.preventDefault();
    // const data = new FormData(e.target);
    const latValue = selectedLocation.lat;
    const longValue = selectedLocation.lng;
    const addressValue = selectedLocation.address;
    const userId = items.userId;
    const employerName = getemployerName;
    const employecontact = getnumber;
    const employeemail = getemailaddress;
    const employepassword = passwordvalue;
    const info = getinformation;
    const company = getcompanyname;
    const updatedemp = {
      userId: userId,
      name: employerName,
      contact: employecontact,
      email: employeemail,
      password: employepassword,
      officeLocation: addressValue,
      longitude: longValue,
      latitude: latValue,
      information: info,
      companyname: company,
      sendadminId: getadminId,
    };
    const employerresult = await fetch(`${apiUrl}/admin/updateemployer`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(updatedemp),
    });
    const updatedData = await employerresult.json();
    if (updatedData.status === 200) {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    } else {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    }
  };
  const passShow = () => {
    setInputType(inputType === "password" ? "text" : "password");
  };
  const changeDocumentStatus = async (updatedemp) => {
    const employerresult = await fetch(`${apiUrl}/admin/changeDocumentStatus`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(updatedemp),
    });
    const updatedData = await employerresult.json();
    if (updatedData.status === 200) {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    } else {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    }
  };
  const uploaddriving_licence = async () => {
    // console.log(image1)
    // e.preventDefault();
    const formData = new FormData();
    formData.append('type', 'driving_licence');
    // formData.append('driving_licence', image1);
    // formData.append('user_id', items.userId);
    // console.log(image1);
    // const formData = {
    //   type: 'driving_licence',
    //   driving_licence: image1,
    //   user_id: items.userId
    // }
    const employerresult = await fetch(`${apiUrl}/admin/uploadDocumentsForAdmin`, {
      // method: "POST",
      // formData,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData),
    });
    const updatedData = await employerresult.json();
    if (updatedData.status === 200) {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    } else {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    }
  };
  const address_upload =  async (e) => {
    // console.log(e)
    const formData = new FormData();
    formData.append('type', 'address');
    formData.append('address', e.target.files[0]);
    formData.append('user_id', items.userId);

    const employerresult = await fetch(`${apiUrl}/admin/uploadDocumentsForAdmin`, {
      method: "POST",
      body: formData,
    });
    const updatedData = await employerresult.json();
    if (updatedData.status === 200) {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    } else {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    }
  };
  const handleSuccessMessageFadeOut = async () => {
    setSuccessMessages((prevMessages) => prevMessages.slice(1));
    // window.location.reload();
    try {
      const postData = {
        employer_id: employerId,
      };
      const res = await fetch(`${apiUrl}/admin/viewemployer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(postData),
      });
      const data = await res.json();
      if (data.status !== 200) {
        throw new Error("Data not found");
      }
      setItems(data.data);
      setEmployername(data.data.name);
      setEmailaddress(data.data.email);
      setInformation(data.data.informations);
      setCompany(data.data.company_name);
      setMobilenumber(data.data.mobile_number);
    } catch (error) {
      console.error("Error ", error);
    }
  };
  return (
    <div className="width90">
      <h2 className="pageTitle">Edit Employer Details</h2>
      <div className="commonCntr">
        <form
          className="form-horizontal"
          method="POST"
          onSubmit={updateemployer}
        >
          <div className="form-group">
            <label className="control-label col-sm-2 label">Name:</label>
            <div className="col-sm-4  mt-1">
              <input
                type="text"
                className="form-control"
                name="name"
                id="name"
                value={employerName}
                onChange={(e) => getname(e)}
              />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Email address:
            </label>
            <div className="col-sm-4  mt-1">
              <input
                type="text"
                className="form-control"
                name="email"
                id="email"
                value={emailaddress}
                onChange={(e) => getemailid(e)}
              />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Informations:
            </label>
            <div className="col-sm-4  mt-1">
              <input
                type="text"
                className="form-control"
                name="info"
                id="info"
                value={information}
                onChange={(e) => getinfo(e)}
              />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Company Name:
            </label>
            <div className="col-sm-4  mt-1">
              <input
                type="text"
                className="form-control"
                name="compName"
                id="compName"
                value={company}
                onChange={(e) => getcompany(e)}
              />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Contact Number:
            </label>
            <div className="col-sm-4  mt-1">
              <input
                type="text"
                className="form-control"
                name="number"
                id="number"
                value={mobilenumber}
                onChange={(e) => getmobilenumber(e)}
              />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Password:</label>
            <div className="col-sm-4  mt-1 position-relative">
              <input
                type={inputType}
                className="form-control"
                name="password"
                id="password"
                value=""
                onChange={(e) => getpassword(e)}
              />
              <AiFillEye className="hide_show" onClick={passShow} />
            </div>
          </div>
          {/* address */}
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Office Location:
            </label>
            <div className="col-sm-10  mt-1 mb-3">
              <span className="d-block">{items.office_location}</span>
              {/* <input type="text" className="form-control" name="address" id="address" defaultValue={items.office_location} /> */}
            </div>
            <div className="mapCss col-sm-10">
              <SearchLocationInput setSelectedLocation={setSelectedLocation} />
              {/* <MapComponent selectedLocation={selectedLocation} /> */}
            </div>
          </div>
          {items?.documents ? (
            items?.documents?.map((e) => {
              return (
                <div className="form-group mt-4">
                  <label className="control-label col-sm-3 label">
                    Document Approval Status
                  </label>
                  <input
                    type="checkbox"
                    id="driving_licence"
                    name="driving_licence"
                    checked={e.status}
                    onChange={() =>
                      changeDocumentStatus({
                        id: e.id,
                        status: !e.status,
                      })
                    }
                  />{" "}
                  <label className="control-label col-sm-2 label">
                    {e.type === "driving_licence"
                      ? "Driving Licence"
                      : "Address Documents"}
                  </label>
                  <div className="col-sm-4  mt-1">
                  <iframe
                      src={e.image}
                      class="img-fluid small-image"
                      alt="No Document uploaded yet"
                    ></iframe>
                    <a target="_blank" href={e.image}>Preview</a>
                  </div>
                </div>
              );
            })
          ) : (
            <></>
          )}
          {items.driving_licence ? <></>:(
            <div>
              <h2>Driving Licence</h2>
              <input
                type="file"
                accept="image/*"
                onChange={handleDivingLicenseChange}
              />
            </div>
          )}
          {items.address_proof ? <></>:(
            <div>
              <h2>Address Proof</h2>
              <input
                type="file"
                accept="image/*"
                onChange={handleAddressChange}
              />
            </div>
          )}
          {/* {items?.documents?.id ? (
            <div className="form-group mt-4">
              <div className="form-group mt-4">
                <label className="control-label col-sm-3 label">
                  Document Approval Status
                </label>
                <input
                  type="checkbox"
                  id="driving_licence"
                  name="driving_licence"
                  checked={items?.documents?.status}
                  onChange={() =>
                    changeDocumentStatus({
                      id: items?.documents?.id,
                      status: !items?.documents?.status,
                    })
                  }
                />{" "}
              </div>

              <label className="control-label col-sm-2 label">
                Driving Licence
              </label>
              <div className="col-sm-4  mt-1">
                <img
                  src={
                    "https://timesaverecruitment.s3.us-east-2.amazonaws.com/" +
                    items?.documents?.driving_licence
                  }
                  class="img-fluid small-image"
                  alt="No Document uploaded yet"
                />
              </div>
              <div className="form-group mt-4">
                <label className="control-label col-sm-2 label">Address</label>
                <div className="col-sm-4  mt-1">
                  <img
                    src={
                      "https://timesaverecruitment.s3.us-east-2.amazonaws.com/" +
                      items?.documents?.address
                    }
                    class="img-fluid small-image"
                    alt="No Document uploaded yet"
                  />
                </div>
              </div>
            </div>
          ) : (
            <></>
          )} */}
          {/* address */}
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button type="submit" className="btn btn-default submitBtn">
                Submit
              </button>
            </div>
          </div>
        </form>
        {successMessages.map((message, index) => (
          <SuccessMessage
            key={index}
            message={message}
            onFadeOut={handleSuccessMessageFadeOut}
          />
        ))}
      </div>
    </div>
  );
}

export default Editemployer;
